interface MenuItem {
    headTitle1?: string;
    headTitle2?: string;
    title?: string;
    icon?: string;
    icon1?: string;
    type: string;
    badgeType?: string;
    active?: boolean;
    isPinned?: boolean;
    path?: string;
    children?: MenuItem[];
    subPages?: string;
}

export const menu: MenuItem[] = [
    {
        title: "Emenu",
        icon: "stroke-ecommerce",
        icon1: "fill-ecommerce",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/Emenu/catalog_list",
                title: "Catalog List",
                type: "link",
                subPages: "Add Catalog , Edit Catalog"
            },
            {
                path: "/Emenu/page_list",
                title: "Page List",
                type: "link",
                subPages: "Add Page , Edit Page"
            },
            {
                path: "/Emenu/category_list",
                title: "Product Category",
                type: "link",
                subPages: "Add Category , Edit Category"
            },
            {
                path: "/Emenu/product_list",
                title: "Product List",
                type: "link",
                subPages: "Add Product , Edit Product"
            },
            {
                path: "/Emenu/condiment_list",
                title: "Condiment List",
                type: "link",
                subPages: "Add Condiment , Edit Condiment"
            },
        ]
    },
    {
        title: "product settings",
        icon: "stroke-knowledgebase",
        icon1: "fill-knowledgebase",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/management/products",
                title: "products",
                type: "link",
                subPages: "products"
            },
            {
                path: "/management/condiments",
                title: "condiments",
                type: "link",
                subPages: "condiments"
            },
            {
                path: "/management/product_groups",
                title: "product groups",
                type: "link",
                subPages: "product groups"
            },
            {
                path: "/management/departments",
                title: "departments",
                type: "link",
                subPages: "departments"
            },
            {
                path: "/management/product_variation",
                title: "product variation",
                type: "link",
                subPages: "product variation"
            },
            {
                path: "/management/static_condiment",
                title: "static condiment",
                type: "link",
                subPages: "static condiment"
            },
            {
                path: "/management/taxes",
                title: "taxes",
                type: "link",
                subPages: "taxes"
            },
        ]
    },
    {
        title: "activity settings",
        icon: "stroke-knowledgebase",
        icon1: "fill-knowledgebase",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/management/promotion",
                title: "promotion",
                type: "link",
                subPages: "promotion"
            },
        ]
    }
];
